import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomeSelect_Jupiter from "../CustomSelect_Jupiter";
import {
  INIT_STATE_SELECTS,
  INDEX,
} from "../../../../constants/driveglobalfilterinitialstates_coral";
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
import moment from "moment";
import $ from "jquery";

function FilterSecondPageErc_Jupiter(props) {
  const [temp_filterdata, setTempFilterData] = useState({
    ...props.secondPageState,
  });
  const [filterdata, setFilterData] = useState({ ...props.secondPageState });
  const [singlevinerr, setSingleVinErro] = useState(false);
  const inputElement = useRef();
  const socref = useRef();

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    setSingleVinErro(false);
    if (enterter_vin != "") {
      if (enterter_vin.indexOf(",") == -1) {
        setFilterData((prestate) => {
          return { ...filterdata, vin_num: enterter_vin };
        });
      } else {
        setSingleVinErro(true);
      }
    } else {
      setSingleVinErro(true);
    }
  };

  const startDateChanged = (date) => {
    setFilterData((prestate) => {
      return { ...filterdata, startDate: date };
    });
  };

  const endDateChanged = (date) => {
    setFilterData((prestate) => {
      return { ...filterdata, endDate: date };
    });
  };

  const changeSoc = (e) => {
    setFilterData((prestate) => {
      return { ...filterdata, soc_per: parseInt(e.target.value) };
    });
  };

  const onsubmit = (e) => {
    e.preventDefault();
    if (inputElement.current.value == "") {
      setSingleVinErro(true);
    } else {
      props.onsubmit(filterdata);
    }
  };

  const onreset = (e) => {
    e.preventDefault();
    setFilterData(temp_filterdata);
    props.onsubmit(temp_filterdata);
    inputElement.current.value = temp_filterdata.vin_num;
  };

  const FirstPageCilcked = () => {
    props.pageChange();
  };

  let count = 0;
  const showblock = () => {
    if (count === 0) {
      $("#filterSearch").css("display", "block");
      count = 1;
    } else {
      $("#filterSearch").css("display", "none");
      count = 0;
    }
  };

  return (
    <>
      <div className="container-fluid mainDiv__">
        <div className="text-end ev-auto">
          <button
            type="button"
            id="filterIcon"
            className="btn btn-outline-primary material-icons ev_filter_icon"
            onClick={showblock}
          >
            filter_alt
          </button>
        </div>
        <div
          className="bg-light  FilterDiv drivediv p-3  mb-3"
          id="filterSearch"
          style={{ display: "none", zIndex: 1 }}
        >
          <form className="row g-3 mt-2 filterForm">
            <div className="row">
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="mb-0">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="select_col_title form-label"
                      >
                        Start Date
                      </label>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        minDate={moment(
                          new Date("2022-07-01T00:00:00.000Z")
                        ).toDate()}
                        maxDate={moment().subtract(1, "days").toDate()}
                        selected={filterdata.startDate}
                        onChange={startDateChanged}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="mb-0">
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="select_col_title form-label"
                      >
                        End Date
                      </label>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        minDate={moment(
                          new Date("2022-07-01T00:00:00.000Z")
                        ).toDate()}
                        maxDate={moment().subtract(1, "days").toDate()}
                        selected={filterdata.endDate}
                        onChange={endDateChanged}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="mb-0">
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="select_col_title form-label"
                      >
                        Vin No / Chassis No
                      </label>
                      <input
                        autoComplete="off"
                        defaultValue={filterdata.vin_num}
                        className="top-filter filter-col"
                        placeholder="Vin No / Chassis No"
                        id="vin_num"
                        ref={inputElement}
                        onBlur={vinnumChanged}
                      />
                      {singlevinerr && (
                        <spna
                          style={{
                            fontSize: "11px",
                            color: "red",
                            fontWeight: 800,
                          }}
                        >
                          * Please enter single Vin Number
                        </spna>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="mb-0">
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="select_col_title form-label"
                      >
                        Discharge SOC % Diff.
                      </label>
                      <select
                        onChange={changeSoc}
                        ref={socref}
                        value={filterdata.soc_per}
                        className="top-filter react-select__option1"
                        id="discharge_load_first"
                        name="discharge_load_first"
                      >
                        <option value={0}>All</option>
                        <option value={20}>&gt;20%</option>
                        <option value={40}>&gt;40%</option>
                        <option value={60}>&gt;60%</option>
                        <option value={80}>&gt;80%</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="mt-3">
                      <label htmlFor className="form-label" />
                      <button
                        className="form-control btn btn-primary"
                        onClick={onsubmit}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="mt-3">
                      <label htmlFor className="form-label" />
                      <button
                        className="form-control btn btn-secondary"
                        onClick={onreset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="mt-3">
                      <label htmlFor className="form-label" />
                      <button
                        className="form-control btn btn-primary"
                        onClick={FirstPageCilcked}
                      >
                        <BsFillSkipBackwardBtnFill />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default FilterSecondPageErc_Jupiter;
